/**
 * MISSION: ZERO-GRAVITY MEDIA MODAL
 * PARADIGM: Global Event Delegation / Entropy Lock
 * TARGET: Override legacy PhotoSwipe & Native Anchors
 */

(function () {
    'use strict';

    // 1. SINGULARITY: Initialize Modal (Lazy Creation)
    function ensureModal() {
        let modal = document.getElementById('ag-modal');
        if (!modal) {
            modal = document.createElement('dialog');
            modal.id = 'ag-modal';
            modal.innerHTML = `
        <button class="ag-close-btn" aria-label="Close" type="button">&times;</button>
        <img src="" alt="Product Detail" loading="eager" draggable="false" />
      `;
            document.body.appendChild(modal);

            // Close Logic: "Vacuum Seal"
            const closeValues = () => {
                modal.close();
                // Clear SRC to free memory and prevent flash on next open
                setTimeout(() => {
                    if (!modal.open) modal.querySelector('img').src = '';
                }, 200);
                document.body.style.overflow = ''; // Release Entropy Lock
            };

            // Button Click
            modal.querySelector('.ag-close-btn').addEventListener('click', (e) => {
                e.stopPropagation();
                closeValues();
            });

            // Backdrop Click (Detect clicks outside image)
            modal.addEventListener('click', (e) => {
                if (e.target === modal) {
                    closeValues();
                }
            });

            // ESC Key (Native dialog handles this, but we need to unlock scroll)
            modal.addEventListener('close', () => {
                document.body.style.overflow = '';
            });

            // Cancel event (fired by ESC)
            modal.addEventListener('cancel', () => {
                document.body.style.overflow = '';
            });
        }
        return modal;
    }

    // 2. INTERCEPTOR: Global Capture Phase Listener
    // Captures events BEFORE they reach specific element listeners (PhotoSwipe)
    document.addEventListener('click', (e) => {
        // Traverse up to find potential triggers
        const trigger = e.target.closest(
            '.product__media-item a, .pswp-link, .product-single__photo, [data-media-id] a, .visual-orbit-trigger'
        );

        // Filter out irrelevant clicks
        if (!trigger) return;

        // Check if we found a valid image source to project
        const bigSrc = trigger.getAttribute('href') || trigger.dataset.orbitSrc || trigger.dataset.zoom || trigger.querySelector('img')?.src;

        // If no valid source (e.g. video link or void), let it pass (or handle differently)
        if (!bigSrc || bigSrc.includes('#') || bigSrc.includes('javascript:')) return;

        // If it looks like a video link, we might want to let standard behavior happen 
        // UNLESS we build video support. For now, we target Images.
        // Heuristic: Check extensions or if it's a raw image URL. 
        // If it's the anchor meant for PhotoSwipe, it's usually an image.

        // 3. OVERRIDE GRAVITY
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation(); // Kills local listeners (PhotoSwipe, jQuery, etc.)

        // 4. ACTIVATE ZERO-GRAVITY
        const modal = ensureModal();
        const modalImg = modal.querySelector('img');

        // Set source
        modalImg.src = bigSrc;

        // Show
        if (!modal.open) {
            modal.showModal();
        }

        // Entropy Lock (Prevent background scroll)
        document.body.style.overflow = 'hidden';

    }, { capture: true }); // <--- CRITICAL: Capture Phase

    console.log('Zero-Gravity: Interceptor Deployed.');

})();
